<div class="contents">
  <div class="dm-page-content mb-25 page-report">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-header">
            <div class="left-area">
              <span class="title">Registos</span>
              <span class="sub-title">Visualize os registos da plataforma</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actionsTop col-12">
      <p-select
        [options]="options"
        [(ngModel)]="selectedOption"
        placeholder="Selecione uma opção"
      ></p-select>
    </div>

    <app-logs-profissionais
      *ngIf="selectedOption === 'profissionais'"
    ></app-logs-profissionais>
    <app-logs-bolseiros
      *ngIf="selectedOption === 'bolseiros'"
    ></app-logs-bolseiros>
  </div>
</div>
